export default __webpack_public_path__ + "static/media/curseball_alone.a6463c80.png";